import { lazy } from 'react';

import LazyWithRetry from '../../../components/shared/LazyWithRetry';
// components
import LazyWithSuspense from '../../../components/shared/LazyWithSuspense';

const TopicManagementMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./TopicManagementMain'),
                'topic-management',
            ) as any,
    ),
);

export default TopicManagementMainLazy;
